import { Widget, WidgetProps } from '../widget';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useProfile } from '@/hooks';

export default function MyProgress({ className, ...props }: WidgetProps) {
  // TODO: get profile stats: lastMonthXP, lastMonthbonusxp, refLinkusage

  const { t } = useTranslation();
  const { profile } = useProfile();
  const progress = useMemo(
    () => [
      {
        icon: 'star-down',
        title: t('Points Earned'),
        description: t('The score the user has earned so far'),
        value: profile.currentXp,
      },
      {
        icon: 'ticket',
        title: t('Tickets Earned'),
        description: t('Ticket won by the user'),
        value: profile?.totalTicket,
      },
      {
        icon: 'tickets',
        title: t('Available Ticket'),
        description: t('Number of available tickets'),
        value: profile?.currentTicket,
      },
      {
        icon: 'calendar',
        title: t('Points Last Month'),
        description: t('Points earned by the user in the last month'),
        value: 0, // TODO: profile?.stats?.lastMonthXP,
      },
      {
        icon: 'star-right',
        title: t('Bonus Points From Last Month'),
        description: t('Bonus points earned by the user in the main tasks.'),
        value: 0, // TODO profile?.stats?.lastMonthBonusXP,
      },
      {
        icon: 'link-circle',
        title: t('Reference Link'),
        description: t('Reference Link'),
        value: profile?.referredByCount,
      },
    ],
    [profile],
  );
  return (
    <Widget
      title={
        <h1 className='md:text-lg lg:text-xl text-[#111827] dark:text-white'>{t('My Progress')}</h1>
      }
      className={`${className}`}
      loading={false}
      {...props}
    >
      <div
        className='-mx-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-6 gap-4
      sm:[&>*:nth-child(4)]:!border-0 sm:divide-x lg:!divide-x divide-y sm:divide-y-0'
      >
        {progress.map((i, k) => (
          <div
            className='flex sm:flex-col items-center
            sm:items-stretch px-4 pt-4 first:pt-0 md:pt-0'
            key={k}
          >
            <div className='mr-5 w-full flex md:block items-center'>
              <i className={`icon-${i.icon} text-2xl dark:text-white/70`} />

              <div>
                <h2 className='text-sm font-medium sm:leading-4 sm:h-8 md:h-10 lg:h-12 xl:text-base text-slate-700 dark:text-white'>
                  {i.title}
                </h2>
                <p className='text-xs text-gray-500 sm:hidden dark:text-white/70'>
                  {i.description}
                </p>
              </div>
            </div>

            <div className='sm:mb-4 text-3xl mr-10 md:mr-0  md:text-5xl text-blue-500 font-bold'>
              {i.value}
            </div>

            {/* <div className='hidden grow md:flex items-end text-xs text-gray-500 sm:block max-w-[150px]'> */}
            {/*   {i.description} */}
            {/* </div> */}

            <div className='hidden sm:block grow items-end text-xs text-gray-500 dark:text-white max-w-[150px]'>
              {i.description}
            </div>
          </div>
        ))}
      </div>
    </Widget>
  );
}
